module.exports = __webpack_public_path__ + "static/media/relogio_icon.ae86c828.svg";